import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { DeleteBridgePoolDialogBody, DeleteBridgePoolDialogProps } from '~src/app/content/DeleteBridgePoolDialog';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { EdgePool } from '~src/ts/resources/EdgePool';
import { IDeleteEdgePoolsResult } from '~src/ts/ServerApi/requests/DeleteEdgePoolsRequest';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

import { Domain } from '../types/Domain';
import { UserDefinedPoolModel } from '../types/PoolModel';

export type DeletePoolButtonProps = Readonly<{
  pool: UserDefinedPoolModel;
  siteId: string;
  refreshEdgePools: () => void;
}>;

export function DeletePoolButton(props: DeletePoolButtonProps) {
  return (
    <span className={'tb-data-grid-icon tb-padded'} data-tb-test-id={'pool-delete-cell'}>
      <ButtonWidget
        title={Messages.deleteMessage()}
        buttonType={ButtonType.Icon}
        testId={'delete-pool-button'}
        onClick={() => openDeletePoolDialog(props.pool, props.siteId, props.refreshEdgePools)}
      >
        <img src={imgPath('trash_14px_small.svg')} alt={Messages.deleteMessage()} />
      </ButtonWidget>
    </span>
  );
}

function openDeletePoolDialog(pool: UserDefinedPoolModel, siteId: string, refreshEdgePools: () => void) {
  const action = (_: DeleteBridgePoolDialogProps) => {
    EdgePool.deletePools({ poolIds: [pool.id], siteId: siteId, bridgeSettingsVersion: '0' })
      .then((result: IDeleteEdgePoolsResult) => {
        refreshEdgePools();
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.bridgeSiteSettingsDeletePoolSuccess() });
        }
        if (result.error) {
          // TODO - ndepass 9/7/21 - Story 1297102: [BridgeSiteSettings] Create Multi-Pool table
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.errorUnknown() });
        }
      });
    return Promise.resolve();
  };

  const domains: Domain[] = Object.values(pool.domains);

  const dialogInstance = openReactActionDialog({
    title: Messages.bridgeSiteSettingsDeletePool(),
    bodyComponent: DeleteBridgePoolDialogBody,
    initialBodyProps: {
      poolName: pool.displayName,
      hasAgents: Object.values(pool.agents).length > 0,
      hasDomains: domains.length > 0,
      domains: domains
    },
    initialDialogState: {},
    actionName: Messages.deleteMessage(),
    action: action,
    isActionDelete: true,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width375px
  });

  return Promise.resolve(dialogInstance.result);
}
